import { getToken, getUser } from "../../utils/commons";
import { getAPICall } from "./axiosCommons";
import Moment from "moment";

// GET NGROK
export const searchStores = async (datefrom, dateto, encoded_by) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "store_locations/search",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(datefrom).format("YYYY-MM-DD"),
        date_to: Moment(dateto).format("YYYY-MM-DD"),
        encoded_by: encoded_by,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};
